import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';

import type { RootState } from '../store/store';

export type DecodedToken = {
  username?: string;
  sub?: string;
  userType?: string;
  isAdmin?: boolean;
  isRefreshToken?: boolean;
  codigoVoluntario?: number | null;
  codigoRegional?: number | null;
  iat?: number;
  exp?: number;
};

export default function useUser(): DecodedToken | null {
  const token = useSelector((state: RootState) => state.auth.accessToken);

  if (!token) return null;

  try {
    const decoded = jwtDecode<DecodedToken>(token);
    return decoded ?? null;
  } catch {
    return null;
  }
}
